import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../home/components/Footer';

const monthlyData = [
  { month: 'Сентябрь 2023', revenue: 264000, units: 10, label: '264 000 ₽', note: 'Старт, первые тесты', color: 'from-slate-400 to-slate-500', badge: '', badgeColor: '' },
  { month: 'Октябрь 2023', revenue: 2250000, units: 98, label: '2 250 000 ₽', note: 'Рост х10 🚀', color: 'from-[#1A2B4C] to-[#2A3B5C]', badge: 'Рост х10', badgeColor: 'bg-[#C5A880]' },
  { month: 'Ноябрь 2023', revenue: 6550000, units: 216, label: '6 550 000 ₽', note: 'Пик сезона (акции) 🔥', color: 'from-[#1A2B4C] to-[#2A3B5C]', badge: 'Пик сезона', badgeColor: 'bg-[#C5A880]' },
  { month: 'Декабрь 2023', revenue: 8760000, units: 102, label: '8 760 000 ₽', note: 'Продажа дорогих позиций 💎', color: 'from-[#C5A880] to-[#D4B890]', badge: 'Рекорд', badgeColor: 'bg-[#1A2B4C]', highlight: true },
  { month: 'Январь 2024', revenue: 3340000, units: 106, label: '3 340 000 ₽', note: 'Финальная распродажа остатков', color: 'from-[#1A2B4C] to-[#2A3B5C]', badge: '', badgeColor: '' },
];

const maxRevenue = Math.max(...monthlyData.map(d => d.revenue));

const infographicSlides = [
  { src: 'https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/6f20121cef691b35dfdc63511014972a.png', label: 'Слайд 1' },
  { src: 'https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/dc8885c7dd49ffd2851393af79fe38a6.png', label: 'Слайд 2' },
  { src: 'https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/58fc555381786531dba02a6c0a6f1898.png', label: 'Слайд 3' },
  { src: 'https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/a71a617de0c2a67cb8bf2d038c0b04d6.png', label: 'Слайд 4' },
  { src: 'https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/e2512391e17871d2541a9c4c4af9da0d.png', label: 'Слайд 5' },
  { src: 'https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/eb0ad0637a55fc958f3f454d9f816408.png', label: 'Слайд 6' },
  { src: 'https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/2ac6edc7ca951d50baf0a6198adef5c0.png', label: 'Слайд 7' },
  { src: 'https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/7c4eefa9b22d6d7acb1dee3d7fcb1610.png', label: 'Слайд 8' },
];

export default function CaseViewsonicOzonPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero */}
      <section className="pt-32 pb-16 bg-gradient-to-br from-[#1A2B4C] to-[#0F1A2E] relative overflow-hidden">
        <div className="absolute top-0 right-0 w-96 h-96 border border-[#C5A880]/20 rounded-full -mr-48 -mt-48"></div>
        <div className="absolute bottom-0 left-0 w-72 h-72 border border-[#C5A880]/20 rounded-full -ml-36 -mb-36"></div>
        <div className="absolute top-1/2 left-1/2 w-64 h-64 border border-[#C5A880]/10 rounded-full -translate-x-1/2 -translate-y-1/2"></div>

        <div className="max-w-7xl mx-auto px-6 relative z-10">
          <Link
            to="/#cases"
            className="inline-flex items-center gap-2 text-[#C5A880] hover:text-white transition-colors mb-8 cursor-pointer"
          >
            <i className="ri-arrow-left-line text-lg"></i>
            <span className="text-sm font-medium" style={{ fontFamily: 'Montserrat, sans-serif' }}>Назад к кейсам</span>
          </Link>

          <div className="inline-block bg-[#C5A880] text-[#1A2B4C] px-5 py-2 rounded-full text-base font-bold mb-6 shadow-lg" style={{ fontFamily: 'Montserrat, sans-serif' }}>
            🚀 Кейс ViewSonic на Ozon
          </div>

          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
            Как за 5 месяцев продать сток техники<br />на 21 млн ₽, который лежал на складе год
          </h1>
          <p className="text-[#C5A880]/90 text-xl mt-2 mb-10" style={{ fontFamily: 'Montserrat, sans-serif' }}>
            Бренд: ViewSonic (Мониторы и интерактивные панели) • Площадка: Ozon • Период: Сентябрь 2023 — Январь 2024
          </p>

          {/* Key stats */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {[
              { icon: 'ri-computer-line', label: 'Ассортимент', value: '26 SKU' },
              { icon: 'ri-trophy-line', label: 'Выручка', value: '21,17 млн ₽' },
              { icon: 'ri-time-line', label: 'Период', value: '5 месяцев' },
              { icon: 'ri-shopping-cart-line', label: 'Продано', value: '532 шт' },
            ].map((stat, i) => (
              <div key={i} className="bg-white/5 backdrop-blur-sm rounded-2xl p-5 text-center border border-[#C5A880]/20 hover:border-[#C5A880]/40 transition-all duration-300">
                <div className="w-10 h-10 flex items-center justify-center mx-auto mb-2">
                  <i className={`${stat.icon} text-2xl text-[#C5A880]`}></i>
                </div>
                <div className="text-2xl font-bold text-white" style={{ fontFamily: 'Playfair Display, serif' }}>{stat.value}</div>
                <div className="text-[#C5A880]/80 text-sm mt-1" style={{ fontFamily: 'Montserrat, sans-serif' }}>{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">

          {/* Challenge — Точка А */}
          <div className="grid md:grid-cols-3 gap-6 mb-16">
            <div className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100 hover:border-[#C5A880] transition-all duration-300 group">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 bg-[#1A2B4C] rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                  <i className="ri-alert-line text-xl text-[#C5A880]"></i>
                </div>
                <h4 className="text-xl font-bold text-slate-900" style={{ fontFamily: 'Playfair Display, serif' }}>📍 Точка А</h4>
              </div>
              <p className="text-gray-700 text-sm font-semibold mb-2" style={{ fontFamily: 'Montserrat, sans-serif' }}>«Замороженный» склад</p>
              <p className="text-gray-600 text-sm leading-relaxed mb-3" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                Товар (дорогостоящая электроника) лежал на складе мёртвым грузом целый год.
              </p>
              <div className="space-y-2 text-sm text-gray-600" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                <p><strong>Состояние:</strong> Карточки товара были созданы формально — «пустышки». Не было ни описания, ни инфографики, ни SEO.</p>
                <p><strong>Результат:</strong> Органического трафика и продаж — 0.</p>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100 hover:border-[#C5A880] transition-all duration-300 group">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 bg-[#1A2B4C] rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                  <i className="ri-computer-line text-xl text-[#C5A880]"></i>
                </div>
                <h4 className="text-xl font-bold text-slate-900" style={{ fontFamily: 'Playfair Display, serif' }}>Ассортимент</h4>
              </div>
              <p className="text-gray-700 text-sm font-semibold mb-3" style={{ fontFamily: 'Montserrat, sans-serif' }}>26 видов мониторов</p>
              <ul className="space-y-2 text-sm text-gray-600" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                {['Офисные мониторы', 'Игровые мониторы', 'Интерактивные панели'].map((item, i) => (
                  <li key={i} className="flex items-start gap-2">
                    <i className="ri-arrow-right-s-line text-[#C5A880] mt-0.5 flex-shrink-0"></i>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100 hover:border-[#C5A880] transition-all duration-300 group">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 bg-[#1A2B4C] rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                  <i className="ri-error-warning-line text-xl text-[#C5A880]"></i>
                </div>
                <h4 className="text-xl font-bold text-slate-900" style={{ fontFamily: 'Playfair Display, serif' }}>Сложность</h4>
              </div>
              <ul className="space-y-2 text-sm text-gray-700" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                {[
                  'Товар хрупкий и технически сложный',
                  'Покупатели требовательны к характеристикам',
                  'Высокая стоимость товара',
                ].map((item, i) => (
                  <li key={i} className="flex items-start gap-2">
                    <i className="ri-arrow-right-s-line text-[#C5A880] mt-0.5 flex-shrink-0"></i>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* What We Did */}
          <div className="bg-gradient-to-br from-[#1A2B4C] to-[#0F1A2E] rounded-2xl p-8 md:p-10 text-white mb-16 relative overflow-hidden">
            <div className="absolute top-0 right-0 w-64 h-64 border border-[#C5A880]/10 rounded-full -mr-32 -mt-32"></div>
            <div className="absolute bottom-0 left-0 w-48 h-48 border border-[#C5A880]/10 rounded-full -ml-24 -mb-24"></div>
            
            <div className="relative z-10">
              <h2 className="text-3xl font-bold mb-4 text-center" style={{ fontFamily: 'Playfair Display, serif' }}>⚙️ Что было сделано (Системный подход)</h2>
              <p className="text-xl text-[#C5A880]/90 text-center mb-8" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                Мы полностью перезапустили продажи, работая в 4 этапа
              </p>

              <div className="grid md:grid-cols-2 gap-5 mb-8">
                {[
                  {
                    icon: 'ri-image-line',
                    title: '1. Упаковка и Контент',
                    items: [
                      '<strong>Техническая проработка:</strong> Расписали все критически важные характеристики (разрешение, матрица, отклик)',
                      '<strong>SEO и Смыслы:</strong> Подготовили подробные описания с ключевыми словами для индексации в поиске Ozon',
                      '<strong>Дизайн:</strong> Разработали продающую инфографику по воронке продаж',
                    ],
                  },
                  {
                    icon: 'ri-calculator-line',
                    title: '2. Экономика и 3. Логистика',
                    items: [
                      '<strong>Юнит-экономика:</strong> Просчитали маржинальность для участия в акциях',
                      '<strong>Модель FBS:</strong> Продажи со своего склада для контроля качества упаковки',
                      'Минимизация боя при транспортировке хрупкого груза',
                    ],
                  },
                ].map((block, i) => (
                  <div key={i} className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-[#C5A880]/20 hover:border-[#C5A880]/40 hover:bg-white/10 transition-all duration-300">
                    <div className="flex items-start gap-4">
                      <div className="w-12 h-12 bg-[#C5A880] rounded-full flex items-center justify-center flex-shrink-0">
                        <i className={`${block.icon} text-2xl text-[#1A2B4C]`}></i>
                      </div>
                      <div>
                        <h5 className="text-lg font-bold mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>{block.title}</h5>
                        <ul className="space-y-1 text-sm text-[#C5A880]/80" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                          {block.items.map((li, j) => (
                            <li key={j} dangerouslySetInnerHTML={{ __html: `• ${li}` }} />
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                ))}

                <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-[#C5A880]/20 hover:border-[#C5A880]/40 hover:bg-white/10 transition-all duration-300 md:col-span-2">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-[#C5A880] rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-advertisement-line text-2xl text-[#1A2B4C]"></i>
                    </div>
                    <div>
                      <h5 className="text-lg font-bold mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>4. Маркетинг и Продвижение</h5>
                      <ul className="space-y-1 text-sm text-[#C5A880]/80" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                        <li>• <strong>Внутренняя реклама:</strong> Запустили «Трафареты» и «Продвижение в поиске» для быстрого набора охватов</li>
                        <li>• <strong>Акции:</strong> Активно участвовали в категорийных акциях электроники</li>
                        <li>• <strong>Работа с базой:</strong> Настроили «Бонусы продавца» и рассылку писем, стимулируя лояльность</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              {/* Infographic Slides */}
              <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-[#C5A880]/20">
                <h5 className="text-xl font-bold mb-2 text-center" style={{ fontFamily: 'Playfair Display, serif' }}>📸 Пример проработки инфографики игрового монитора</h5>
                <p className="text-sm text-[#C5A880]/80 text-center mb-6" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  Каждый слайд выстроен по воронке продаж: от привлечения внимания до закрытия возражений
                </p>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                  {infographicSlides.map((slide, i) => (
                    <div key={i} className="bg-white rounded-lg overflow-hidden shadow-md border border-[#C5A880]/30">
                      <div className="w-full h-40 overflow-hidden">
                        <img
                          src={slide.src}
                          alt={`Инфографика монитора - ${slide.label}`}
                          className="w-full h-full object-contain"
                        />
                      </div>
                      <div className="p-2 bg-[#C5A880] text-center">
                        <p className="text-xs font-bold text-[#1A2B4C]" style={{ fontFamily: 'Montserrat, sans-serif' }}>{slide.label}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Results */}
          <div className="mb-16">
            <h2 className="text-3xl font-bold text-slate-900 mb-4 text-center" style={{ fontFamily: 'Playfair Display, serif' }}>📊 Точка Б: Результаты (Сентябрь — Январь)</h2>
            <p className="text-center text-gray-600 mb-10 text-lg" style={{ fontFamily: 'Montserrat, sans-serif' }}>
              За 5 месяцев активной работы нам удалось полностью реализовать сток
            </p>

            {/* Key Metrics */}
            <div className="grid md:grid-cols-2 gap-6 mb-10">
              <div className="bg-gradient-to-br from-[#1A2B4C] to-[#0F1A2E] rounded-2xl p-8 text-white shadow-xl text-center border border-[#C5A880]/20">
                <div className="text-sm font-medium mb-2 opacity-90" style={{ fontFamily: 'Montserrat, sans-serif' }}>Итоговая выручка</div>
                <div className="text-5xl font-bold mb-2 text-[#C5A880]" style={{ fontFamily: 'Playfair Display, serif' }}>21,17 млн ₽</div>
                <div className="text-lg opacity-90" style={{ fontFamily: 'Montserrat, sans-serif' }}>За 5 месяцев</div>
              </div>
              <div className="bg-gradient-to-br from-[#1A2B4C] to-[#0F1A2E] rounded-2xl p-8 text-white shadow-xl text-center border border-[#C5A880]/20">
                <div className="text-sm font-medium mb-2 opacity-90" style={{ fontFamily: 'Montserrat, sans-serif' }}>Продано товаров</div>
                <div className="text-5xl font-bold mb-2 text-[#C5A880]" style={{ fontFamily: 'Playfair Display, serif' }}>532 шт</div>
                <div className="text-lg opacity-90" style={{ fontFamily: 'Montserrat, sans-serif' }}>Полная реализация стока</div>
              </div>
            </div>

            {/* Bar Chart */}
            <div className="bg-white rounded-2xl p-8 shadow-xl border border-gray-100 mb-10">
              <h3 className="text-2xl font-bold text-slate-900 mb-2 text-center" style={{ fontFamily: 'Playfair Display, serif' }}>📈 Динамика роста по месяцам</h3>
              <p className="text-center text-gray-500 mb-8 text-sm" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                Наглядно виден разгон продаж к высокому сезону и успешная реализация дорогих позиций
              </p>

              <div className="relative h-72 flex items-end justify-between gap-3 mb-4">
                {monthlyData.map((data, index) => (
                  <div key={index} className="flex-1 flex flex-col items-center">
                    <div className="w-full relative" style={{ height: '240px' }}>
                      <div
                        className={`absolute bottom-0 w-full bg-gradient-to-t ${data.color} ${data.highlight ? 'shadow-2xl shadow-[#C5A880]/40' : ''} rounded-t-xl transition-all duration-500 hover:opacity-90`}
                        style={{ height: `${(data.revenue / maxRevenue) * 100}%` }}
                      >
                        <div className={`absolute -top-14 left-1/2 transform -translate-x-1/2 ${data.highlight ? 'bg-[#C5A880] text-[#1A2B4C] scale-110' : 'bg-[#1A2B4C] text-white'} px-3 py-2 rounded-xl text-xs font-bold whitespace-nowrap shadow-xl`} style={{ fontFamily: 'Montserrat, sans-serif' }}>
                          {data.label}
                          <div className="text-xs opacity-80 mt-0.5">{data.units} шт</div>
                        </div>
                      </div>
                    </div>
                    <div className={`text-xs ${data.highlight ? 'text-[#C5A880] font-bold' : 'text-gray-500 font-medium'} mt-3 text-center leading-tight`} style={{ fontFamily: 'Montserrat, sans-serif' }}>
                      {data.month.split(' ')[0]}<br />{data.month.split(' ')[1]}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Monthly Cards */}
            <div className="space-y-4 mb-10">
              {monthlyData.map((data, i) => (
                <div
                  key={i}
                  className={`rounded-xl p-5 border-2 ${data.highlight ? 'bg-gradient-to-br from-[#1A2B4C] to-[#0F1A2E] border-[#C5A880]' : i === 1 ? 'bg-gradient-to-br from-[#F8F9FA] to-white border-[#C5A880]/30' : 'bg-gradient-to-br from-gray-50 to-white border-gray-200'}`}
                >
                  <div className="flex items-center justify-between flex-wrap gap-3">
                    <div>
                      <div className="flex items-center gap-3 mb-1">
                        <span className={`font-bold text-lg ${data.highlight ? 'text-white' : 'text-slate-900'}`} style={{ fontFamily: 'Playfair Display, serif' }}>{data.month}</span>
                        {data.badge && (
                          <span className={`${data.badgeColor} ${data.highlight ? 'text-white' : 'text-[#1A2B4C]'} text-xs font-bold px-3 py-1 rounded-full`} style={{ fontFamily: 'Montserrat, sans-serif' }}>
                            {data.badge}
                          </span>
                        )}
                      </div>
                      <p className={`text-sm ${data.highlight ? 'text-[#C5A880]/80' : 'text-gray-500'}`} style={{ fontFamily: 'Montserrat, sans-serif' }}>{data.note}</p>
                    </div>
                    <div className="text-right">
                      <div className={`text-2xl font-bold ${data.highlight ? 'text-[#C5A880]' : 'text-[#1A2B4C]'}`} style={{ fontFamily: 'Playfair Display, serif' }}>{data.label}</div>
                      <div className={`text-sm ${data.highlight ? 'text-white/80' : 'text-gray-500'}`} style={{ fontFamily: 'Montserrat, sans-serif' }}>{data.units} шт</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Key Achievement */}
            <div className="bg-gradient-to-br from-[#1A2B4C] to-[#0F1A2E] rounded-2xl p-8 mb-16 border border-[#C5A880]/30">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-[#C5A880] rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-trophy-line text-2xl text-[#1A2B4C]"></i>
                </div>
                <div>
                  <h3 className="font-bold text-white mb-3 text-xl" style={{ fontFamily: 'Playfair Display, serif' }}>💡 Итог</h3>
                  <div className="space-y-2 text-sm text-white/80" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                    <p>
                      <strong className="text-[#C5A880]">Склад, который простаивал год, был полностью распродан за сезон.</strong>
                    </p>
                    <p>
                      Карточки товаров вышли в топ выдачи благодаря качественному наполнению и агрессивному маркетингу.
                    </p>
                    <p className="text-[#C5A880] font-semibold">
                      Результат: 21,17 млн ₽ выручки и 532 проданных единицы техники за 5 месяцев.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* CTA */}
          <div className="text-center py-12 bg-gradient-to-br from-[#1A2B4C] to-[#0F1A2E] rounded-3xl border border-[#C5A880]/30 relative overflow-hidden">
            <div className="absolute top-0 right-0 w-48 h-48 border border-[#C5A880]/10 rounded-full -mr-24 -mt-24"></div>
            <div className="absolute bottom-0 left-0 w-40 h-40 border border-[#C5A880]/10 rounded-full -ml-20 -mb-20"></div>
            <div className="relative z-10">
              <h2 className="text-3xl font-bold text-white mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>Есть товар на складе?</h2>
              <p className="text-[#C5A880]/80 text-lg mb-8 max-w-2xl mx-auto" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                Мы знаем, как реализовать сток быстро и выгодно. Выстроим систему продаж под ваш товар.
              </p>
              <Link
                to="/#lead-form"
                className="inline-block bg-[#C5A880] text-[#1A2B4C] px-10 py-5 rounded-full text-xl font-bold hover:bg-[#D4B890] hover:shadow-2xl hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer"
                style={{ fontFamily: 'Montserrat, sans-serif' }}
              >
                Реализовать мой сток на маркетплейсах
              </Link>
            </div>
          </div>

        </div>
      </section>

      <Footer />
    </div>
  );
}